// The full-match prompt asks for one "Explanation" string per category, but the model sometimes
// answers with one explanation per pair ({ stress_level_vs_stress_tolerance: "..." }).
// Turns either shape into display text, one pair per line.
export const explanationText = (value: unknown): string => {
	if (typeof value === "string")
		return value;
	if (Array.isArray(value))
		return value.map(explanationText).filter(Boolean).join("\n");
	if (value && typeof value === "object")
		return Object.entries(value as Record<string, unknown>)
			.map(([pair, text]) => `${pair.replace(/_/g, " ")}: ${explanationText(text)}`)
			.join("\n");
	return "";
};
